import { useEffect, useState } from "react";
import API from "../../services/api";
import "./teachers.css";

export default function TeacherAttendance() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));
  const today = new Date().toISOString().split("T")[0];

  const [date, setDate] = useState(today);
  const [records, setRecords] = useState([]);
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");

  /* ---------- LOAD CLASSES ---------- */
  const loadClasses = async () => {
    try {
      const res = await API.get("/school-admin/classes/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setClasses(res.data.classes || []);
    } catch (e) { console.error(e); }
  };

  /* ---------- LOAD SECTIONS ---------- */
  const loadSections = async (cid) => {
    if (!cid) return setSections([]);
    try {
      const res = await API.get(`/school-admin/sections/${cid}/`, {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setSections(res.data.sections || []);
    } catch (e) { console.error(e); }
  };

  /* ---------- LOAD ATTENDANCE ---------- */
  const loadAttendance = async () => {
    try {
      const res = await API.get(
        `/school-admin/teacher-attendance/?date=${date}&class_id=${classId}&section_id=${sectionId}`,
        { headers: { "X-SCHOOL-ID": school.school.id } }
      );
      setRecords(res.data.records || []);
    } catch (e) { console.error(e); }
  };

  /* ---------- DOWNLOAD REPORT ---------- */
  const downloadReport = () => {
    const params = new URLSearchParams({
      date,
      class_id: classId || "",
      section_id: sectionId || "",
    }).toString();
    window.open(
      `${API.defaults.baseURL.replace(/\/$/, "")}/school-admin/teacher-attendance/report/?${params}`,
      "_blank"
    );
  };

  /* ---------- MARK ATTENDANCE ---------- */
  const markAttendance = async (teacherId, status) => {
    try {
      await API.post(
        "/school-admin/teacher-attendance/mark/",
        { teacher_id: teacherId, date, status },
        { headers: { "X-SCHOOL-ID": school.school.id } }
      );
      loadAttendance();
    } catch { alert("Failed to mark attendance"); }
  };

  useEffect(() => { loadClasses(); }, []);
  useEffect(() => { loadSections(classId); }, [classId]);
  useEffect(() => { loadAttendance(); }, [date, classId, sectionId]);

  return (
    <div className="teacher-container">

      {/* ══ HERO ══ */}
      <div className="teacher-hero">
        <div>
          <span className="teacher-hero-icon">📋</span>
          <h2>Teacher Attendance</h2>
          <p>Mark and track daily attendance for all teachers</p>
        </div>
        <button className="btn-download" onClick={downloadReport}>
          ⬇ Download Report
        </button>
      </div>

      {/* ══ FILTERS ══ */}
      <div className="filter-row">
        <select value={classId} onChange={e => setClassId(e.target.value)}>
          <option value="">All Classes</option>
          {classes.map(c => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>

        <select
          value={sectionId}
          onChange={e => setSectionId(e.target.value)}
          disabled={!classId}
        >
          <option value="">All Sections</option>
          {sections.map(s => (
            <option key={s.id} value={s.id}>{s.name}</option>
          ))}
        </select>

        <input
          type="date"
          value={date}
          onChange={e => setDate(e.target.value)}
        />
      </div>

      {/* ══ TABLE ══ */}
      <div className="teacher-table-card">
        <table className="teacher-table">
          <thead>
            <tr>
              <th>Teacher</th>
              <th>Status</th>
              <th>Mark</th>
              <th>Time</th>
            </tr>
          </thead>

          <tbody>
            {records.length === 0 ? (
              <tr>
                <td colSpan="4">
                  <div className="teacher-empty-state">
                    <span style={{ fontSize: 44 }}>📋</span>
                    <strong>No Records Found</strong>
                    <p>No attendance data for this date / filter.</p>
                  </div>
                </td>
              </tr>
            ) : (
              records.map(r => (
                <tr key={r.teacher_id}>
                  <td style={{ fontWeight: 600 }}>{r.teacher}</td>

                  <td>
                    <span className={`status ${r.status || "not-marked"}`}>
                      {r.status ? r.status.toUpperCase() : "NOT MARKED"}
                    </span>
                  </td>

                  <td>
                    <button
                      className="btn-present"
                      onClick={() => markAttendance(r.teacher_id, "present")}
                    >
                      ✓ Present
                    </button>
                    <button
                      className="btn-absent"
                      onClick={() => markAttendance(r.teacher_id, "absent")}
                    >
                      ✗ Absent
                    </button>
                  </td>

                  <td style={{ color: "#64748b", fontSize: "13px" }}>
                    {r.time || "—"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

    </div>
  );
}
